import ProgressBar from "./progress_bar";

/**
 * ModalLoading
 */

export const ModalLoading = ({
  loading,
  message,
  children,
}: React.PropsWithChildren<{ loading: boolean, message?: string }>) => {
  return (
    <div className="size-full relative">
      <div className="size-full relative">
        {children}
      </div>
      {
        loading &&
        <div className="absolute size-full z-50 top-0 left-0 flex justify-center items-center">
          <div className="flex-col w-48 p-4 rounded-lg gap-2 border border-stone-500 flex justify-center items-center bg-[#FFFFFF] dark:bg-[#393939]">
            <div className="w-24">
              <img src="/images/mini-logo.png" alt="logo gdol" />
            </div>
            <div className="w-full">
              <ProgressBar />
              <p className="text-black dark:text-white text-center">{message ?? "Salvando"}</p>
            </div>
          </div>
        </div>
      }
    </div>
  );
}